import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles } from '@/js/libs/use-auth';

import GenAI from 'src/scenes/GenAI';
import Status from 'src/scenes/Status';

const index = true;

export const genAIObject = inferRouteObject({
  path: 'gen-ai',
  element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: GenAI.Helmet,
      children: [
        { index, element: <Navigate to='./chat/new' replace /> },
        {
          path: 'chat',
          children: [
            { index, element: <Navigate to='./new' replace /> },
            { path: ':conversationId', Component: GenAI.AiChat },
          ],
        },
        {
          path: 'settings',
          children: [
            { index, element: <Navigate to='./agents' replace /> },
            {
              path: 'agents',
              children: [
                { index, Component: GenAI.AiSettingsAgents },
                { path: 'create', Component: GenAI.AiSettingsAgentForm },
                { path: 'edit/:agentId', Component: GenAI.AiSettingsAgentForm },
              ],
            },
            {
              path: 'mcp-servers',
              children: [
                { index, Component: GenAI.AiSettingsMcpServers },
                { path: 'create', Component: GenAI.AiSettingsMcpServerForm },
                { path: 'edit/:serverId', Component: GenAI.AiSettingsMcpServerForm },
              ],
            },
            {
              path: 'brand-kits',
              children: [
                { index, Component: GenAI.AiSettingsBrandKits },
                { path: 'create', Component: GenAI.AiSettingsBrandKitForm },
                { path: 'edit/:brandKitId', Component: GenAI.AiSettingsBrandKitForm },
              ],
            },
          ],
        },
      ],
    },
  ],
});
